import { useState, useEffect } from "react";
import AnnouncementBar from "../components/AnnouncementBar";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection";
import WelcomeSection from "../components/WelcomeSection";
import FeaturedProducts from "../components/FeaturedProducts";
import WhySection from "../components/WhySection";
import AboutSection from "../components/AboutSection";
import SocialProofSection from "../components/SocialProofSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <main className="min-h-screen bg-brand-cream overflow-x-hidden">
      <AnnouncementBar />
      <Header />
      <HeroSection />
      <WelcomeSection />
      <FeaturedProducts />
      <WhySection />
      <AboutSection />
      <SocialProofSection />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default HomePage;
